"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialTemplates = void 0;
const templateNames_1 = require("../templateNames");
// these template are not handled by default generator which means they need extra steps during scaffolding
exports.specialTemplates = [
    {
        id: "non-sso-tab-ssr-cs",
        name: templateNames_1.TemplateNames.TabSSR,
        language: "csharp",
        description: "Simple Teams Tab App",
    },
    {
        id: "sso-tab-ssr-cs",
        name: templateNames_1.TemplateNames.SsoTabSSR,
        language: "csharp",
        description: "Simple Teams Tab App with SSO",
    },
    {
        id: "declarative-agent-with-action-from-existing-api",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromExistingApiSpec,
        language: "none",
        description: "",
    },
    {
        id: "declarative-agent-with-action-from-existing-api-csharp",
        name: templateNames_1.TemplateNames.DeclarativeAgentWithActionFromExistingApiSpec,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-rag-custom-api-ts",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomApi,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-rag-custom-api-js",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomApi,
        language: "javascript",
        description: "",
    },
    {
        id: "teams-agent-with-data-custom-api-v2-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomApi,
        language: "csharp",
        description: "",
    },
    {
        id: "teams-agent-with-data-custom-api-v2-python",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomApi,
        language: "python",
        description: "",
    },
    {
        id: "message-extension-with-existing-api",
        name: templateNames_1.TemplateNames.MessageExtensionWithExistingApiSpec,
        language: "common",
        description: "",
    },
    {
        id: "message-extension-with-existing-api-csharp",
        name: templateNames_1.TemplateNames.MessageExtensionWithExistingApiSpec,
        language: "csharp",
        description: "",
    },
];
//# sourceMappingURL=special.js.map